import React, {useEffect, useState} from 'react';
import css from './Menu.module.scss'
import close from '../../../images/menu-close.svg'
import avatar from '../../../images/user-placeholder.png'
import line from '../../../images/white-curve-line.svg'
import {NavLink, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {logout, setToken} from "../../../redux/auth/auth-actions";
import {setProfile, setUser} from "../../../redux/user/user-actions";
import {getTrips} from "../../../redux/logbook/logbook-thunks";
import {useTranslation} from "react-i18next";
import i18next from "i18next";

const Menu = ({closeMenu, isShow, setToken, user, profile, setTheme, isDark, ...props}) => {
  const [isLogout, setIsLogout] = useState(false)
  const {t} = useTranslation()
  const menu = [
    {
      name: t('logbook'),
      link: '/logbook'
    },
    {
      name: t('profile'),
      link: '/logbook/profile/licenses'
    },
    {
      name: t('licenses'),
      link: '/logbook/profile/licenses'
    },
    {
      name: t('myTeam'),
      link: '/logbook/profile/command'
    },
    {
      name: t('yachts'),
      link: '/logbook/profile/yachts'
    },
    {
      name: t('resume'),
      link: '/logbook/profile/resume'
    }
  ]

  const logout = () => {
    localStorage.removeItem('token')
    setToken(false)
    setIsLogout(true)
    props.logout()
  }

  useEffect(() => {
    if(user && props.trips === null) {
      props.getTrips()
    }
  }, [user])

  const onLangPress = (lang) => {
    localStorage.setItem('lang', lang)
    i18next.changeLanguage(lang)
  }

  if(isLogout) {
    return <Redirect to={'/logbook/auth'} />
  }

  return (
    <div className={css.menu}>
      <div style={{left: isShow ? '0vw' : '-50vw'}} className={`${css.menu__row}`}>
        <div className={css.menu__col}>
          <div className={css.menu__centerred}>
            <div className={css.menu__avatarWrapper}>
              <img src={profile?.image_link ? `data:image/png;base64,${profile?.image_link}` : avatar} alt="" className={css.menu__avatar}/>
            </div>
            <div className={css.menu__name}>
              {`${profile?.first_name ?? ''} ${profile?.last_name ?? ''}`}
            </div>
          </div>
          <div className={css.menu__items}>
            <div className={css.menu__item}>
              <p className={css.menu__count}>{props.experience?.miles ?? 0}</p>
              <p className={css.menu__caption}>
                {t('nauticalMiles')}
              </p>
            </div>
            <div className={css.menu__item}>
              <p className={css.menu__count}>{props.experience?.days ?? 0}</p>
              <p className={css.menu__caption}>
                {t('daysInTheSea')}
              </p>
            </div>
          </div>
          <div className={css.menu__info}>
            <div className={css.menu__infoItem}>
              <p className={css.menu__underTitle}>
                {t('email')}
              </p>
              <p className={css.menu__value}>
                {user?.email}
              </p>
            </div>
            {profile?.phone_number && <div className={css.menu__infoItem}>
              <p className={css.menu__underTitle}>
                {t('phone')}
              </p>
              <p className={css.menu__value}>
                {profile.phone_number}
              </p>
            </div>}
          </div>
        </div>
        <img src={line} alt="" className={css.menu__line}/>
      </div>
      <div style={{right: isShow ? '0vw' : '-52vw'}} className={`${css.menu__row}`}>
        <img src={line} alt="" className={css.menu__line}/>
        <div className={css.menu__col}>
          <div className={css.menu__abs}>
            <div className={css.menu__themeText}>{t('darkTheme')}</div>
            <button style={{
              background: isDark ? '#4CD964' : '',
              justifyContent: isDark? 'flex-start' : ''
            }} onClick={() => setTheme(!isDark)} className={css.menu__check}>
              <div className={css.menu__circle} />
            </button>
            <div className={css.menu__langs}>
              <button onClick={() => onLangPress('ru')} className={`${css.menu__lang} ${i18next.language === 'ru' && css.menu__langActive}`}>
                Ru
              </button>
              <button onClick={() => onLangPress('en')} className={`${css.menu__lang} ${i18next.language === 'en' && css.menu__langActive}`}>
                | Eng
              </button>
            </div>
            <button onClick={closeMenu} className={css.menu__close}>
              <img src={close} alt=""/>
            </button>
          </div>
          <ul className={css.menu__list}>
            {menu.map((item, index) => <NavLink to={item.link} key={index} onClick={closeMenu}
                                                className={css.menu__listItem}>
              {item.name}
            </NavLink>)}
            <button onClick={logout} className={css.menu__listItem}>
              {t('signOut')}
            </button>
          </ul>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  profile: state.userReducer.profile,
  trips: state.logbookReducer.trips,
  experience: state.logbookReducer.experience
})

export default connect(mapStateToProps, {setToken, setUser, setProfile, getTrips, logout})(React.memo(Menu));
